"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var facebookV2_svg_1 = __importDefault(require("@ClientAssets/icons/social/facebookV2.svg"));
var linkedinV2_svg_1 = __importDefault(require("@ClientAssets/icons/social/linkedinV2.svg"));
var twitterV2_svg_1 = __importDefault(require("@ClientAssets/icons/social/twitterV2.svg"));
exports.default = (function (createUi, projectSharer, getSocialLinks, onDisabledClick, isDisabled, link) {
    return createUi(require("./Promote.html"), {
        isDisabled: isDisabled,
        onDisabledClick: onDisabledClick,
        getSocialLinks: getSocialLinks,
        link: link,
        shareButtons: [
            {
                platform: "twitter",
                icon: twitterV2_svg_1.default,
            },
            {
                platform: "facebook",
                icon: facebookV2_svg_1.default,
            },
            {
                platform: "linkedin",
                icon: linkedinV2_svg_1.default,
            },
        ],
        trackSocialShare: projectSharer.trackSocialShare,
    });
});
